var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-page-holder",attrs:{"id":"divHealthWarningsWrapper"}},[_c('VueWrapperNarrow',[_c('div',{staticClass:"hw-wrapper",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }